import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';

const SwitchContext = /*#__PURE__*/createContext(null);
SwitchContext.displayName = 'SwitchContext';
function SwitchProvider({
  checked,
  children,
  id,
  size,
  slotCount
}) {
  return jsx(SwitchContext.Provider, {
    value: {
      checked,
      id,
      size,
      slotCount
    },
    children: children
  });
}

export { SwitchContext, SwitchProvider };
